import { createFileRoute, notFound, redirect } from "@tanstack/react-router"

import { $rqIotApiClient } from "@/api/iot"
import { getBoardsQueryOptions } from "@/api/query/boardsQueryOptions"
import { getXOrganizationHeaders } from "@/api/utils"
import { ensureValidQueryData } from "@/api/utils/ensureValidQueryData"
import { routeGuard } from "@/lib/routing/beforeLoad"
import { recentsStore } from "@/store/recents"

export const Route = createFileRoute("/_authlayout/_header/devices/$id")({
  beforeLoad: async ({ context, params }) => {
    await routeGuard(context)

    return {
      deviceQueryOptions: $rqIotApiClient.queryOptions("get", `/iot/v2/devices/{id}`, {
        params: { header: getXOrganizationHeaders(context.spaceStorage.getSpace()), path: { id: params.id } }
      })
    }
  },
  loader: async ({ context: { queryClient, deviceQueryOptions }, params }) => {
    // Must be read before validating, since a determinate 4xx evicts the query. `cause`
    // cannot stand in for this: it tracks the route slot, so navigating from one
    // device straight to a bogus id is still `"stay"`.
    const wasCached = queryClient.getQueryData(deviceQueryOptions.queryKey) !== undefined

    const [{ data: device, error }] = await Promise.all([
      ensureValidQueryData(deviceQueryOptions),
      queryClient.query({ ...getBoardsQueryOptions(), staleTime: "static" })
    ])

    if (error) {
      // Try purging recents in case the device was deleted
      recentsStore.getState().removeRecent(params.id)

      // Deleted under us → back to the list. Otherwise a bad id → not found.
      if (wasCached) throw redirect({ to: "/devices" })
      throw notFound()
    }

    return { device }
  },
  head: ctx => ({
    meta: [
      {
        title: `${ctx.loaderData?.device.name || "Device"} | Arduino Cloud`
      }
    ]
  })
})
